import React from 'react';
import {FormattedMessage} from 'react-intl';

export const NoOptionsMessage = () => (
    <div className="autosuggest-input__menu-notice">
        <FormattedMessage id="notFound" />
    </div>
);
